import { responseError } from './errorMessages';

export interface ReadingConfig {
  asrMaxConnections: number;
  recordingMinSeconds: number;
  recordingMaxSeconds: number;
  wsMaxSeconds: number;
  wsIdleSeconds: number;
  commitmentText: string;
  confirmationCodeEnabled: boolean;
}
export const READING_DEFAULTS: ReadingConfig = {
  asrMaxConnections: 1, recordingMinSeconds: 5, recordingMaxSeconds: 30, wsMaxSeconds: 45, wsIdleSeconds: 10,
  commitmentText: '本人确认今天由本人使用郑好修师傅账号接单并提供服务，承诺遵守平台服务规范。', confirmationCodeEnabled: true,
};

export interface RuntimeConfig extends ReadingConfig {
  defaultAccessToken: string;
  storageMode: 'LOCAL' | 'CLOUD';
  modelUrl: string;
  wasmBaseUrl: string;
  recordRetentionDays?: number;
  enrollmentAgreement?: import('./api').Agreement;
  verificationAgreement?: import('./api').Agreement;
  commitmentAgreement?: import('./api').Agreement;
}

export const LOCAL_CONFIG: RuntimeConfig = { ...READING_DEFAULTS, defaultAccessToken: '', storageMode: 'LOCAL', modelUrl: '', wasmBaseUrl: '' };

export interface ModelResources { modelUrl: string; wasmBaseUrl: string }

/** 本地使用固定路径；云模式直接使用管理员填写的完整地址，不再拼接共同前缀。 */
export function modelResources(config: RuntimeConfig): ModelResources {
  if (config.storageMode === 'LOCAL') {
    return { modelUrl: '/models/face_landmarker.task', wasmBaseUrl: '/mediapipe/wasm' };
  }
  if (!config.modelUrl || !config.wasmBaseUrl) throw new Error('云存储地址尚未配置完整，请联系管理员');
  return { modelUrl: config.modelUrl, wasmBaseUrl: config.wasmBaseUrl.replace(/\/+$/, '') };
}

/** 只接收服务端白名单中的公开配置，其他字段不能参与页面初始化。 */
export async function loadPublicConfig(): Promise<RuntimeConfig> {
  const controller = new AbortController();
  const timer = window.setTimeout(() => controller.abort(), 8000);
  try {
    const response = await fetch('/api/verification/publicConfig', { cache: 'no-store', signal: controller.signal });
    if (!response.ok) throw new Error(await responseError(response));
    const config = await response.json() as Partial<RuntimeConfig>;
    if (!['LOCAL', 'CLOUD'].includes(config.storageMode ?? '') || typeof config.modelUrl !== 'string' || typeof config.wasmBaseUrl !== 'string') {
      throw new Error('站点配置读取异常，请联系管理员');
    }
    return { ...READING_DEFAULTS, ...config } as RuntimeConfig;
  } finally {
    window.clearTimeout(timer);
  }
}
